import { IPrismicPictoTextRowItem, IPictoTextRow, IItem } from './types';

export const mapPictoTextRow = ({ prismicContent }): IPictoTextRow => {
  const items: IItem[] = prismicContent.items.map(
    (item: IPrismicPictoTextRowItem) => {
      const {
        image: { url: image, alt },
      } = item;

      return {
        ...item,
        image,
        alt,
      };
    },
  );

  const pictoTextRow: IPictoTextRow = { items };

  return pictoTextRow;
};
